import React, { Component } from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { RootCloseWrapper } from 'react-overlays';
import loadingImage from '../img/loading.svg'

class SortByLoading extends Component {
  render() {
    if(this.props.loadingState){
      return (
        <div className='grouped-reports-loading'>
          <div>
            <img src={loadingImage} alt="loading" />
          </div>
          <h5 className="loading-text">
            در حال دسته بندی داده ها...
          </h5>
        </div>
      );
    }
    else{
      return null;
    }
  }
}


class CustomToggle extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.onClick(e);
  }

  render() {
    return (
      <div className = { (this.props.openState ? 'open-menu ' : '') + 'dropdown-btn sort-button ' } onClick={this.handleClick}>
        {this.props.children}
      </div>
    );
  }
}

class CustomMenu extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      suborder: 'duration',
      sortDirection: '+'
    };

    this.setSuborder = this.setSuborder.bind(this);
    this.setDirection = this.setDirection.bind(this);
  }

  setSuborder ( suborder_ ){
    let currentDirection = this.state.sortDirection;
    this.setState({
      suborder: suborder_,
      sortDirection: currentDirection
    })
    if(currentDirection === '+') currentDirection = '';
    this.props.sortFunc( currentDirection +  suborder_);
    
  }

  setDirection ( sortDirection_ ){
    let currentSuborder = this.state.suborder;
    this.setState({
      suborder: currentSuborder,
      sortDirection: sortDirection_ 
    })
    if(sortDirection_ === '+') sortDirection_ = ''; 
    this.props.sortFunc( sortDirection_ +  currentSuborder );
  }

  render() {
    let currentSuborder = this.props.suborder || 'duration';
    let currentDirection = '+';
    if(currentSuborder[0] === '-'){
      currentDirection = '-';
      currentSuborder = currentSuborder.slice(1);
    }
    return (
      <div className="dropdown-menu group-menu" >
        <ul className="group-list">
          <MenuItem className="filter-controller filter-header" header  > مرتب سازی براساس </MenuItem>
          <MenuItem className="filter-controller row"   >
            <div className="checkbox-container col-sm-2">
              <input className="checkbox-input" type="checkbox" 
                onChange={ ()=>{} } 
                checked={ currentSuborder === 'name' || false } 
                id="sort-title-checkbox" 
              />
            </div>
            <div className="label-container col-sm-6" onClick={ () => {  this.setSuborder('name'); this.props.toggleMenu(); } } >
              <label className="checkbox-label" htmlFor="sort-title-checkbox">
                عنوان
              </label>
            </div> 
          </MenuItem>
          <MenuItem className="filter-controller row" >
          <div className="checkbox-container col-sm-2">
            <input className="checkbox-input" type="checkbox" 
              onChange={()=>{}} 
              checked={ currentSuborder === 'duration' || false } id="sort-duration-checkbox" />
          </div>
          <div className="label-container col-sm-6" onClick={ () => { this.setSuborder('duration'); this.props.toggleMenu(); } } >
            <label className="checkbox-label" htmlFor="sort-duration-checkbox">
              مدت
            </label>
          </div>
          </MenuItem>
          <MenuItem className="filter-controller filter-header" header  > جهت مرتب سازی </MenuItem>
          <MenuItem className="filter-controller row"  >
          <div className="checkbox-container col-sm-2">
            <input className="checkbox-input" type="checkbox" 
              onChange={()=>{}} 
              checked={ currentDirection === '+' || false }
              id="sort-ascneding-checkbox" 
            />
          </div>
          <div className="label-container col-sm-6" onClick={ () => { this.setDirection('+'); this.props.toggleMenu(); } }>
            <label className="checkbox-label" htmlFor="sort-ascneding-checkbox">
              صعودی
            </label>
          </div>
          </MenuItem>
          <MenuItem className="filter-controller row"  >
          <div className="checkbox-container col-sm-2">
            <input className="checkbox-input" type="checkbox" 
              onChange={()=>{}}
              checked={ currentDirection === '-' || false } id="sort-descneding-checkbox" />
          </div>
          <div className="label-container col-sm-6" onClick={ () => { this.setDirection('-'); this.props.toggleMenu(); } } >
            <label className="checkbox-label" htmlFor="sort-descneding-checkbox">
              نزولی
            </label>
          </div>
          </MenuItem>
        </ul>
      </div>
    );
  }
}

export class SummarySort extends Component {
  constructor(props, context) {
    super(props, context); 
    this.state = {
      open: false
    };
    this.toggleOpenState = this.toggleOpenState.bind(this)   
    this.setOpenStateToFalse = this.setOpenStateToFalse.bind(this)   
  }
  
  setOpenStateToFalse() {
    this.setState({open : false});
  }

  toggleOpenState() {
    this.setState({open : !this.state.open});
  }

  render(){
    let suborder = this.props.suborder;
    let sortDirection = 'صعودی';
    if(!!suborder && suborder[0] === '-') {
      suborder = suborder.slice(1);
      sortDirection = 'نزولی';
    }
    if(suborder === 'duration') suborder = 'مدت';
    else if(suborder === 'name') suborder = 'نام';

    return (
    <RootCloseWrapper onRootClose={this.setOpenStateToFalse}>
      <Dropdown open={this.state.open} onToggle={this.toggleOpenState} id="dropdown-custom-menu">
      <SortByLoading loadingState={this.props.loadingState} />      
        <CustomToggle openState={this.state.open} bsRole="toggle">
          <span className="small-text-span" >
            مرتب شده بر اساس
          </span>

          <span className='bold-text-span' >
            {' ' + suborder + ' (' + sortDirection + ')' }
          </span>
          <span className="caret" /> 
        </CustomToggle>

        <CustomMenu toggleMenu={this.toggleOpenState}  bsRole="menu" {...this.props} />
      </Dropdown>
    </RootCloseWrapper>)
  }
}